import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import style from "./style.module.scss";
import { InputRange } from "./InputRange";

const Filters = ({ map, featureGeocoder, radius, setRadius }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!featureGeocoder || !map) return;

    const maxZoom = 12;
    const minZoom = 9;
    const maxRadius = 30;
    const center = featureGeocoder.geometry.coordinates;

    const zoom =
      radius === 0
        ? maxZoom
        : maxZoom -
          (Math.log(radius + 1) / Math.log(maxRadius + 1)) *
            (maxZoom - minZoom);

    map.easeTo({
      center: center,
      zoom: zoom,
      duration: 1000,
    });
  }, [featureGeocoder, radius, map]);

  return (
    <div className={style.filters} id={"map-refocus-point"}>
      <div className={style.rangeContainer}>
        <div className={style.data}>
          <div className={style.radius}>{t("Radius")}</div>
          <div className={style.value}>{radius} km</div>
        </div>
        <div className={style.range}>
          <InputRange
            value={radius}
            setValue={setRadius}
            min={0}
            max={30}
            step={5}
          />
        </div>
      </div>
    </div>
  );
};

export default Filters;
